import { Breadcrumb as AntdBreadcrumb } from 'antd';
import { createGuardedComponent } from '../../provider/create-guarded-component';

export type { BreadcrumbProps } from 'antd';

export const Breadcrumb = createGuardedComponent(AntdBreadcrumb) as typeof AntdBreadcrumb;
